import { Form, InputNumber } from 'antd';
import './PricingInputField.scss';

interface IpricingInputFieldProps {
  dataName: string;
  label: string;
  suffixSymbol: string;
  placeholder: string;
  componentSize?: string;
  initialValue?: number;
  currentValue?: number;
  isRequired?: boolean;
  isDisabled?: boolean;
  maxValue?: number;
  hasError?: boolean;
}

/**
 * Campo numérico de pricing basado en el InputNumber de antd, integrado al Form.
 * @param hasError - si es true aplica estilos de error (label y borde en rojo) para destacar el campo como requerido.
 */
const PricingInputField = (props: IpricingInputFieldProps) => {
  const {
    dataName,
    label,
    suffixSymbol,
    placeholder,
    componentSize,
    initialValue,
    currentValue,
    isRequired,
    isDisabled,
    maxValue,
    hasError
  } = props;
  const sizeStyles = componentSize ? componentSize : '';
  const unfilledStyles = !!currentValue ? '' : 'unfilled';
  const disabledStyles = isDisabled ? 'disabled' : '';
  const errorStyles = hasError ? 'error' : '';

  const numberFormater = new Intl.NumberFormat('es-MX');
  const formatPrice = (value?: string) => `${value ? numberFormater.format(+value) : 0} ${suffixSymbol}`;
  const parsePrice = (value?: string) => value!.replace(suffixSymbol, '').replaceAll(',', '');

  return (
    <div className={`pricingInputField ${sizeStyles} ${unfilledStyles} ${disabledStyles} ${errorStyles}`}>
      <label className="sizePricingInputField">{label}</label>
      <Form.Item
        name={dataName}
        initialValue={initialValue}
        rules={[{ required: isRequired, message: isRequired ? 'Este campo es requerido' : '' }]}
      >
        <InputNumber
          formatter={formatPrice}
          parser={parsePrice}
          className={`pricingInput ${unfilledStyles} ${disabledStyles}`}
          placeholder={placeholder}
          disabled={!!isDisabled}
          min={'0'}
          max={maxValue ? `${maxValue}` : undefined}
        />
      </Form.Item>
    </div>
  );
};

export default PricingInputField;
